import { render, staticRenderFns } from "./EzModal.vue?vue&type=template&id=50089942&"
import script from "./EzModal.vue?vue&type=script&lang=js&"
export * from "./EzModal.vue?vue&type=script&lang=js&"
import style0 from "./EzModal.vue?vue&type=style&index=0&id=50089942&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports